import Box from '@mui/material/Box';
import dynamic from 'next/dynamic';
import React, { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone';
import RegistrationButton from '../../Custom/Buttons/RegistrationButton';

const AlertComponent = dynamic(() => import('./AlertComponent'), {ssr: false});

const styles = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: '2px',
    borderRadius: '2px',
    borderColor: '#2196f3',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
}


const FileUploader = (props) => {

    const {
        onSubmit,
        directory = "",
        maxFiles = 2,
        disabled = false,
        loading = false,
        ...rest
    } = props;

    const [files, setFiles] = useState([]);
    const [message, setMessage] = useState('');
    
    useEffect(() => {
        if(message != "" && files.length != 0){
            setMessage('');
        }
    }, [files])
    

    const onDrop = useCallback(acceptedFiles => {
        setFiles([...files, ...acceptedFiles])
    }, [files])

      
    const {
        acceptedFiles,
        setAcceptedFiles,
        fileRejections,
        getRootProps,
        getInputProps,
    } = useDropzone({    
        maxFiles:maxFiles,
        onDrop,
        accept: props?.accept || {}
    });

    const acceptedFileItems = files.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    const handleSubmit = async () => {
        const result = await onSubmit(files);
        if(result?.status == 'success'){
            setFiles([]);
            setMessage('Your files have successfully uploaded.');
        }
    }
  
    return (
        <div>
            <Box 
                sx={{
                    ...styles,
                    ':focus': {
                        borderColor: '#2196f3'
                    },
                    ':hover': {
                        borderColor: '#0489f4',
                    }
                }}
                {...getRootProps({ className: 'dropzone',})}>
                <input {...getInputProps()} />
                <p>Drag and drop some files here, or click to upload your PDFS</p>
                {/* <em>(2 files are the maximum number of files you can drop here)</em> */}
            </Box>
            <aside className="mt-2">
                <ul>{acceptedFileItems}</ul>
                {/* <h4>Rejected files</h4>
                <ul>{fileRejectionItems}</ul> */}
            </aside>
            {files.length > 0 && (
                <RegistrationButton
                    loading={loading}
                    disabled={disabled}
                    className="mt-1" 
                    onClick={handleSubmit}
                    variant="contained"
                >
                    Upload Files
                </RegistrationButton>
            )}

            {
                message != "" && (
                    <AlertComponent
                        severity="success"
                        title={message}
                    />
                )
            }
        
        </div>
    )
}

export default FileUploader